export default __webpack_public_path__ + "static/media/wutzu-app.f2347709.png";